import { SHARED_MODULE_SPECIFIER_PATTERN, SURFACE_NAME_PATTERN } from "./surface-manifest.js";
//#region src/surfaces/surface-grammar.ts
/**
* Parsers for the two names a surface declaration carries (layered shell surfaces, D16, R-20 Q1).
*
* The patterns and the length caps are the contract's, in `surface-manifest.ts`; this module
* declares neither (R-20 Q1: the lead declares the patterns, the caps sit beside them so the JSON
* Schema and the wire twin can read them). Each parser checks the length before the regex, and
* every quantifier in both patterns runs over a class that excludes the next literal, so a match is
* linear in the input.
*/
const SURFACE_NAME = new RegExp(SURFACE_NAME_PATTERN);
const SHARED_MODULE_SPECIFIER = new RegExp(SHARED_MODULE_SPECIFIER_PATTERN);
/**
* Parse a surface name, or return `null`.
*
* `null` for a non-string, a string longer than `SURFACE_NAME_MAX_LENGTH` (64), or a string that
* does not match `SURFACE_NAME_PATTERN`: `invoice-list`, `.v1`, `x.v0`, `X.v1`, `x.v1.2`,
* `x.v10000`. Pure; never throws.
*/
function parseSurfaceName(value) {
	if (typeof value !== "string" || value.length > 64 || !SURFACE_NAME.test(value)) return null;
	const split = value.lastIndexOf(".v");
	return {
		base: value.slice(0, split),
		major: Number(value.slice(split + 2))
	};
}
/**
* Parse a `sharedDependencies` value, or return `null`.
*
* `null` for a non-string, a string longer than `SHARED_MODULE_SPECIFIER_MAX_LENGTH` (128), or a
* string that does not match `SHARED_MODULE_SPECIFIER_PATTERN`: `react`, `react@^19`,
* `react@19.1`, `react@latest`, `React@19`, `@zion@1`, `react@01`, `a@10000`. Pure; never throws.
*/
function parseSharedModuleSpecifier(value) {
	if (typeof value !== "string" || value.length > 128 || !SHARED_MODULE_SPECIFIER.test(value)) return null;
	const split = value.lastIndexOf("@");
	return {
		name: value.slice(0, split),
		major: Number(value.slice(split + 1))
	};
}
//#endregion
export { parseSharedModuleSpecifier, parseSurfaceName };

//# sourceMappingURL=surface-grammar.js.map